import { createLogger } from '@ringba/core/logger';

export const logger = createLogger('[RUM]');

let isActive = false;

/** True once the RUM SDK has initialised successfully. */
export function isRumActive(): boolean {
  return isActive;
}

export function markRumActive(): void {
  isActive = true;
}
